import { render, staticRenderFns } from "./modern-french.vue?vue&type=template&id=d9ae3668"
import script from "./modern-french.vue?vue&type=script&lang=js"
export * from "./modern-french.vue?vue&type=script&lang=js"
import style0 from "./modern-french.vue?vue&type=style&index=0&id=d9ae3668&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports